import { hasImageInput, clampTo } from '../../tools';
import type { grsaiModelConfig } from '../types';

export const googleConfigs: Record<string, grsaiModelConfig> = {
    'nano-banana-2-1': {
        // https://qmy27nhsd9.apifox.cn/452392911e0
        apiPath: '/v1/api/generate',
        pollApiPath: '/v1/api/result?id={id}',
        statusMapping: {
            taskIdPath: 'id',
            createErrorPath: 'error',
            statePath: 'status',
            success: ['succeeded'],
            failed: ['failed', 'violation'],
            processing: ['running'],
            errorPath: 'error',
            imageUrlPath: 'results[0].url',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'nano-banana-2.1',
                    prompt: prompt,
                    aspectRatio: aspectRatio === 'match' ? 'auto' : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:3', '3:4', '4:1', '1:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                    imageSize: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K'),
                    images: image_urls.slice(0, 16),
                    replyType: 'async',
                };
            } else {
                return {
                    model: 'nano-banana-2.1',
                    prompt: prompt,
                    aspectRatio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:3', '3:4', '4:1', '1:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                    imageSize: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K'),
                    replyType: 'async',
                };
            };
        },
    },
    'nano-banana-2': {
        // https://qmy27nhsd9.apifox.cn/452392911e0
        apiPath: '/v1/api/generate',
        pollApiPath: '/v1/api/result?id={id}',
        statusMapping: {
            taskIdPath: 'id',
            createErrorPath: 'error',
            statePath: 'status',
            success: ['succeeded'],
            failed: ['failed', 'violation'],
            processing: ['running'],
            errorPath: 'error',
            imageUrlPath: 'results[0].url',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'nano-banana-2',
                    prompt: prompt,
                    aspectRatio: aspectRatio === 'match' ? 'auto' : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:3', '3:4', '4:1', '1:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                    imageSize: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K'),
                    // 图像 URL
                    images: image_urls.slice(0, 16),
                    // system
                    replyType: 'async',
                };
            } else {
                return {
                    model: 'nano-banana-2',
                    prompt: prompt,
                    aspectRatio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:3', '3:4', '4:1', '1:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                    imageSize: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K'),
                    // system
                    replyType: 'async',
                };
            };
        },
    },
    'nano-banana-pro': {
        // https://qmy27nhsd9.apifox.cn/452409160e0
        apiPath: '/v1/api/generate',
        pollApiPath: '/v1/api/result?id={id}',
        statusMapping: {
            taskIdPath: 'id',
            createErrorPath: 'error',
            statePath: 'status',
            success: ['succeeded'],
            failed: ['failed', 'violation'],
            processing: ['running'],
            errorPath: 'error',
            imageUrlPath: 'results[0].url',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'nano-banana-pro',
                    prompt: prompt,
                    aspectRatio: aspectRatio === 'match' ? 'auto' : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                    imageSize: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K'),
                    // 图像 URL
                    images: image_urls.slice(0, 16),
                    // system
                    replyType: 'async',
                };
            } else {
                return {
                    model: 'nano-banana-pro',
                    prompt: prompt,
                    aspectRatio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                    imageSize: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K'),
                    // system
                    replyType: 'async',
                };
            };
        },
    },
    'nano-banana': {
        // https://qmy27nhsd9.apifox.cn/452409160e0
        apiPath: '/v1/api/generate',
        pollApiPath: '/v1/api/result?id={id}',
        statusMapping: {
            taskIdPath: 'id',
            createErrorPath: 'error',
            statePath: 'status',
            success: ['succeeded'],
            failed: ['failed', 'violation'],
            processing: ['running'],
            errorPath: 'error',
            imageUrlPath: 'results[0].url',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'nano-banana',
                    prompt: prompt,
                    aspectRatio: aspectRatio === 'match' ? 'auto' : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                    // 图像 URL
                    images: image_urls.slice(0, 16),
                    // system
                    replyType: 'async',
                };
            } else {
                return {
                    model: 'nano-banana',
                    prompt: prompt,
                    aspectRatio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                    // system
                    replyType: 'async',
                };
            };
        },
    },
};